module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-button-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "pure-button radio radio-left",
    class: {
      active: _vm.isCommercial
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue('Commercial')
      }
    }
  }, [_vm._v("Commercial\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "pure-button radio radio-right",
    class: {
      active: _vm.isResidential
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue('Residential')
      }
    }
  }, [_vm._v("Home\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b29bad0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/AddressType.vue
// module id = 400
// module chunks = 1